import { render, staticRenderFns } from "./examHouse.vue?vue&type=template&id=315c6a59&scoped=true"
import script from "./examHouse.vue?vue&type=script&lang=js"
export * from "./examHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c6a59",
  null
  
)

export default component.exports